import type { InputPropTypes } from '@/components/core/Input/types';
import type { SelectableCountry } from '@/types';

import React from 'react';
import { ChevronDown } from 'react-feather';
import { InputLeftAddon } from '@chakra-ui/react';

import {
  Box,
  Icon,
  Input,
  InputGroup,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
} from '@/components';
import Afghanistan from '@/svgs/afghanistan.svg';
import Iraq from '@/svgs/iq.svg';
import Iran from '@/svgs/ir.svg';

const MobileInput: React.FC<{
  selectedCountry?: SelectableCountry;
  setSelectedCountry?: React.Dispatch<React.SetStateAction<SelectableCountry>>;
  inputProps: InputPropTypes;
}> = ({ inputProps, selectedCountry, setSelectedCountry }) => {
  const countryIcons = {
    iran: Iran,
    iraq: Iraq,
    afghanistan: Afghanistan,
  };

  const showCountrySelector = setSelectedCountry !== undefined;

  return (
    <Stack flexDir="row" w="100%" gap={0}>
      <Menu isLazy>
        <InputGroup>
          <Input
            w="100%"
            borderRadius={showCountrySelector ? '0 10px 10px 0' : '10px'}
            dir="ltr"
            type="tel"
            {...inputProps}
          />
          {showCountrySelector && (
            <InputLeftAddon
              bgColor="grayAlpha.200"
              mt={inputProps.label ? '29px' : '5px'}
              borderRadius="10px 0 0 10px"
              cursor="pointer"
              paddingInlineStart={0}
              borderWidth={0}
            >
              <Box h="full" w="1px" bg="primary.50" me={2} />
              <MenuButton type="button">
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Icon as={ChevronDown} color="gray.800" />
                  <Icon
                    h={5}
                    w={8}
                    as={countryIcons[selectedCountry || 'iran']}
                  />
                </Box>
              </MenuButton>
            </InputLeftAddon>
          )}
        </InputGroup>
        {setSelectedCountry && (
          <MenuList minW="50px">
            {Object.entries(countryIcons).map(([country, icon]) => {
              return (
                <MenuItem
                  key={country}
                  minW="50px"
                  onClick={() =>
                    setSelectedCountry(country as SelectableCountry)
                  }
                >
                  <Icon h={5} w={8} as={icon} />
                </MenuItem>
              );
            })}
          </MenuList>
        )}
      </Menu>
    </Stack>
  );
};

export default MobileInput;
